import mixpanel from 'mixpanel-browser'

const EVENT_NAME = 'CoronaFocus'

export default function trackFocus(field) {
  mixpanel.track(EVENT_NAME, { attributes: field })
}
